export default "__VITE_ASSET__DHyhcTuO__"